import { LoadableLazy } from '@confluence/loadable';

export const LazyWhiteBoardPublishDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-WhiteBoardPublishDiscoveryDialog" */ '../src/whiteboards/WhiteBoardPublishDiscoveryDialog.tsx'
			)
		).WhiteBoardPublishDiscoveryDialog,
});
